import { Container } from "../../components/FormPreviewer/Container";
import { Form } from "../../components/FormPreviewer/Form";
import { Previewer } from "../../components/FormPreviewer/Previewer";

export const UpsellTab = () => (
  <Container>
    <Form />
    <Previewer />
  </Container>
);
